import { useNavigate } from "react-router-dom";

interface BreadcrumbProps {
  items: { label: string; path?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <nav className="flex items-center gap-2 text-xs text-alvinegro-muted mb-6">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && <i className="ri-arrow-right-s-line text-alvinegro-muted/50"></i>}
          {item.path ? (
            <button
              onClick={() => navigate(item.path!)}
              className="hover:text-alvinegro-black transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-alvinegro-black font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}